export default {
	"query": {
		"queryToAccept": "ยอมรับ",
		"isProject": "เป็นโครงการหรือไม่",
		"customerName": "ชื่อผู้รับบริการ",
		"packingWay": "การบรรจุ",
		"distributionTimes": "ความถี่ในการจัดส่ง",
		"startTime": "วันที่เริ่มต้นที่คาดไว้",
		"neededUnloading": "ช่องทางการจัดจำหน่าย",
		"lastFile": "เอกสารแนบล่าสุด",
		"ageingRequirements": "ข้อบังคับเกี่ยวกับข้อจำกัด",
		"acceptTime": "เวลารับ",
		"acceptName": "ผู้รับโอน",
		"handleTime": "เวลายื่นคำขอ",
		"handlePerson": "ผู้ยื่นคำขอ",
		"note": "หมายเหตุ",
		"feedBack": "ข้อเสนอแนะ",
		"submitUser": "ผู้ยื่น",
		"transportationType": "ประเภทของการขนส่ง",
		"submitTime": "เวลาที่ยื่น",
		"customerProfile": "ข้อมูลประวัติลูกค้า",
		"temperatureRule": "ข้อกำหนดเกี่ยวกับอุณหภูมิ",
		"applicationInformation": "ข้อมูลการยื่นคำขอ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/query/query.js